// @mui
import {
  Box,
  Card,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
// components
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import {
  CoffeeChatTableRow,
} from './';


const TooltipContent = () => {
  return (
    <Box sx={{ maxWidth: "100%", width: 350 }}>
      <Typography variant="subtitle2">
        파트타임 제안은 크루가 커피챗을 수락해야 진행할 수 있어요.
      </Typography>
      <Typography variant="body2">
        크루가 아직 응답 대기중이거나,<br/>커피챗을 거절했다면 파트타임 제안을 진행할 수 없습니다.
      </Typography>
    </Box>
  )
}

const TABLE_HEAD = [
  { id: 'nickname', label: '크루 닉네임 - 포지션', align: 'left' },  // id, 상세 포지션 or 자동매칭 포지션
  { id: 'status', label: '진행 단계', align: 'left', tooltipMessage: <TooltipContent /> },
  { id: 'sender', label: '제안 보낸 사람', align: 'left' },
];

// ----------------------------------------------------------------------

export default function CoffeeChatTable({ coffeeChats, reload }) {
  return (
    <Card>
      <Scrollbar>
        <TableContainer sx={{ py: 2, px: 1 }}>
          <Table size={'medium'}>
            <CoffeeChatTableHead
              headLabel={TABLE_HEAD}
              sx={{ whiteSpace: 'nowrap' }}
            />
            <TableBody>
              {coffeeChats && coffeeChats.map((row, idx) => (
                <CoffeeChatTableRow
                  key={idx}
                  row={row}
                  reload={reload}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
    </Card>
  )
};

function CoffeeChatTableHead({
  headLabel,
  sx,
}) {
  return (
    <TableHead sx={sx}>
      <TableRow>
        {headLabel.map((headCell) => (
          headCell.tooltipMessage ? (
            <Tooltip
              key={headCell.id}
              title={headCell.tooltipMessage}
              placement="bottom"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    p: 1,
                    textAlign: "center",
                    width: 350,
                    maxWidth: "none",
                  },
                }
              }}
            >
              <TableCell
                key={headCell.id}
                sx={{ width: headCell.width, minWidth: headCell.minWidth }}
              >
                <Stack direction="row" alignItems="center" justifyContent="left">
                  {headCell.label}
                  <Iconify icon="eva:info-fill" minWidth={20} minHeight={20} sx={{ ml: 1, color: "text.disabled" }} />
                </Stack>
              </TableCell>
            </Tooltip>
          ) : (
            <TableCell
              key={headCell.id}
              align={headCell.align || 'left'}
              sx={{ width: headCell.width, minWidth: headCell.minWidth }}
            >
              {headCell.label}
            </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
};
